(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5455],{

/***/ 73610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87459);
/* harmony import */ var _badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_badge_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82807);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70254);
/* harmony import */ var remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6138);
/* harmony import */ var remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96175);
/* harmony import */ var remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5__);







function Badge(param) {
    let { type , variant ="default" , size ="medium"  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    switch(type){
        case "bonus":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().bonus), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Gift2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("bonus")
                    })
                ]
            });
        case "discount":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().discount), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_PercentFillIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    size: 20
                })
            });
        case "popular":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "".concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popular), " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[variant], " ").concat((_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default())[size]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FlashlightFillIcon__WEBPACK_IMPORTED_MODULE_5___default()), {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_badge_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
                        children: t("popular")
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {});
    }
}


/***/ }),

/***/ 66868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8303);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3949);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function PrimaryButton(param) {
    let { children , disabled , onClick , type ="button" , icon , loading =false , size ="medium" , id , fullWidth =true , rounded =true , danger =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        id: id,
        type: type,
        className: "".concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primaryBtn), " ").concat((_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], " ").concat(disabled ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : "", " ").concat(fullWidth ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullWidth) : "", " ").concat(rounded ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rounded) : "", " ").concat(danger ? (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().danger) : ""),
        disabled: disabled || loading,
        onClick: onClick,
        children: !loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                icon ? icon : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text),
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: 22
        })
    });
}


/***/ }),

/***/ 21630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Empty; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93708);
/* harmony import */ var _empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_empty_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66868);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49369);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* eslint-disable @next/next/no-img-element */ 




function Empty(param) {
    let { text , buttonText , link ="/"  } = param;
    const { push  } = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/delivery.webp",
                    alt: "Empty"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                    children: text
                }),
                !!buttonText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_empty_module_scss__WEBPACK_IMPORTED_MODULE_4___default().actions),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_button_primaryButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: ()=>push(link),
                        children: buttonText
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 80869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FallbackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50937);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71415);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 



function FallbackImage(param) {
    let { src , alt ="image" , onError , style , fill , width , height , ...props } = param;
    const isValidSrc = src && (src.startsWith("/") || src.startsWith("http://") || src.startsWith("https://"));
    if (!isValidSrc) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        ...props,
        style: style,
        src: src,
        alt: alt,
        title: alt,
        fill: fill,
        width: width,
        height: height,
        className: (_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().root),
        onError: (e)=>{
            e.target.style.visibility = "hidden";
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
    });
}


/***/ }),

/***/ 57686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ WEEK; }
/* harmony export */ });
const WEEK = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday"
];


/***/ }),

/***/ 55455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ShopList; }
});

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23934);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(59108);
// EXTERNAL MODULE: ./containers/shopList/shopList.module.scss
var shopList_module = __webpack_require__(31431);
var shopList_module_default = /*#__PURE__*/__webpack_require__.n(shopList_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+system@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+styled@_oja7ubotzrzctrclxreoqqilcu/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(18438);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(74647);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(57238);
// EXTERNAL MODULE: ./components/shopCard/shopCard.module.scss
var shopCard_module = __webpack_require__(11445);
var shopCard_module_default = /*#__PURE__*/__webpack_require__.n(shopCard_module);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(36291);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/shopLogo/shopLogo.module.scss
var shopLogo_module = __webpack_require__(50782);
var shopLogo_module_default = /*#__PURE__*/__webpack_require__.n(shopLogo_module);
// EXTERNAL MODULE: ./utils/getImage.ts
var getImage = __webpack_require__(19276);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(80869);
;// CONCATENATED MODULE: ./components/shopLogo/shopLogo.tsx





function ShopLogo(param) {
    let { data  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (shopLogo_module_default()).logo,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
            fill: true,
            src: (0,getImage/* default */.Z)(data.logo_img),
            alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
            sizes: "60px",
            quality: 90
        })
    });
}

// EXTERNAL MODULE: ./containers/shopBadges/shopBadges.module.scss
var shopBadges_module = __webpack_require__(34892);
var shopBadges_module_default = /*#__PURE__*/__webpack_require__.n(shopBadges_module);
// EXTERNAL MODULE: ./components/badge/badge.tsx
var badge = __webpack_require__(73610);
// EXTERNAL MODULE: ./utils/commerce.ts
var commerce = __webpack_require__(21053);
;// CONCATENATED MODULE: ./containers/shopBadges/shopBadges.tsx





function ShopBadges(param) {
    let { data  } = param;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shopBadges_module_default()).badge,
        children: [
            data.is_recommended && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "popular",
                variant: !!((ref = data.discount) === null || ref === void 0 ? void 0 : ref.length) || !!data.bonus ? "circle" : "default",
                size: "large"
            }),
            (0,commerce/* showsPrice */.Q$)(data) && !!((ref1 = data.discount) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "discount",
                variant: data.is_recommended || !!data.bonus ? "circle" : "default",
                size: "large"
            }),
            (0,commerce/* canPurchase */.Sz)(data) && !!data.bonus && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                type: "bonus",
                variant: data.is_recommended || !!((ref2 = data.discount) === null || ref2 === void 0 ? void 0 : ref2.length) ? "circle" : "default",
                size: "large"
            })
        ]
    });
}

// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(72526);
// EXTERNAL MODULE: ./hooks/useShopWorkingSchedule.tsx
var useShopWorkingSchedule = __webpack_require__(47951);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(33733);
;// CONCATENATED MODULE: ./components/verifiedComponent/verifiedComponent.tsx


function VerifiedComponent() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        style: {
            display: "block",
            minWidth: "16px",
            height: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* VerifiedIcon */.SA, {})
    });
}

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(73503);
;// CONCATENATED MODULE: ./components/shopCard/shopCard.tsx











function ShopCard(param) {
    let { data , compact =false  } = param;
    var ref, ref1, ref2, ref3;
    const { t  } = (0,useLocale/* default */.Z)();
    const { isShopClosed , workingSchedule  } = (0,useShopWorkingSchedule/* default */.Z)(data);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: "/shop/".concat(data.id),
        className: "".concat((shopCard_module_default()).wrapper, " ").concat(compact ? (shopCard_module_default()).compact : ""),
        children: [
            !compact && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shopCard_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                    fill: true,
                    src: (0,getImage/* default */.Z)(data.background_img),
                    alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                    sizes: "400px",
                    quality: 90
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (shopCard_module_default()).shopLogo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopLogo, {
                    data: data
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (shopCard_module_default()).body,
                children: [
                    compact ? (data.is_recommended || !!((ref1 = data.discount) === null || ref1 === void 0 ? void 0 : ref1.length) || !!data.bonus) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (shopCard_module_default()).flowBadges,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopBadges, {
                            data: data
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopBadges, {
                        data: data
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shopCard_module_default()).titleContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                title: (ref2 = data.translation) === null || ref2 === void 0 ? void 0 : ref2.title,
                                className: "".concat((shopCard_module_default()).title, " ").concat(!(data === null || data === void 0 ? void 0 : data.verify) && (shopCard_module_default()).maxWidth),
                                children: (ref3 = data.translation) === null || ref3 === void 0 ? void 0 : ref3.title
                            }),
                            !!(data === null || data === void 0 ? void 0 : data.verify) && /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedComponent, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (shopCard_module_default()).text,
                        children: !isShopClosed ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                workingSchedule === null || workingSchedule === void 0 ? void 0 : workingSchedule.from,
                                " - ",
                                workingSchedule === null || workingSchedule === void 0 ? void 0 : workingSchedule.to
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("closed")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (shopCard_module_default()).rating,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                value: (data === null || data === void 0 ? void 0 : data.r_avg) || 0,
                                readOnly: true,
                                size: "small",
                                precision: 0.5,
                                name: "ratingIcon",
                                color: "var(--orange)",
                                className: (shopCard_module_default()).ratingIcon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (shopCard_module_default()).ratingCount,
                                children: (data === null || data === void 0 ? void 0 : data.r_count) || 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(82807);
// EXTERNAL MODULE: ./components/button/load-more.tsx
var load_more = __webpack_require__(55078);
// EXTERNAL MODULE: ./components/empty/empty.tsx
var empty = __webpack_require__(21630);
// EXTERNAL MODULE: ./utils/shopAlphabet.ts
var shopAlphabet = __webpack_require__(80462);
;// CONCATENATED MODULE: ./containers/shopList/shopList.tsx









function ShopList(param) {
    let { title , shops , loading , fetchNextPage , hasNextPage =false , fetchingNextPage =false , compact =false , initial ="" , onInitialChange , error =false , onRetry  } = param;
    const { t , i18n  } = (0,es/* useTranslation */.$G)();
    const copy = (0,shopAlphabet/* shopAlphabetCopy */.Sy)(i18n.language);
    const showAlphabet = !!onInitialChange;
    const selectedInitial = (0,shopAlphabet/* normalizeShopInitial */.PK)(initial);
    const isDesktop = (0,useMediaQuery/* default */.Z)("(min-width:1140px)");
    const handleLoadNexPage = ()=>{
        if (hasNextPage && fetchNextPage) {
            fetchNextPage();
        }
    };
    if (!showAlphabet && !loading && !(shops === null || shops === void 0 ? void 0 : shops.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(empty["default"], {
            text: t("no.shops.found")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "".concat((shopList_module_default()).container, " ").concat(compact ? (shopList_module_default()).compact : ""),
        "aria-busy": loading || fetchingNextPage,
        style: {
            display: !showAlphabet && !loading && shops.length === 0 ? "none" : "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (shopList_module_default()).wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shopList_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (shopList_module_default()).title,
                        children: title
                    })
                }),
                showAlphabet && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shopList_module_default()).alphabet,
                    role: "group",
                    "aria-label": t("manufacturers.initial.label", {
                        defaultValue: copy.label
                    }),
                    children: shopAlphabet/* SHOP_INITIALS.map */.Mp.map((letter)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (shopList_module_default()).initial,
                            "aria-pressed": selectedInitial === letter,
                            onClick: ()=>{
                                return onInitialChange === null || onInitialChange === void 0 ? void 0 : onInitialChange(letter);
                            },
                            children: letter || t("manufacturers.initial.all", {
                                defaultValue: copy.all
                            })
                        }, letter || "all");
                    })
                }),
                showAlphabet && error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (shopList_module_default()).feedback,
                    role: "alert",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("manufacturers.initial.error", {
                                defaultValue: copy.error
                            })
                        }),
                        onRetry && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: onRetry,
                            children: t("manufacturers.initial.retry", {
                                defaultValue: copy.retry
                            })
                        })
                    ]
                }),
                showAlphabet && !loading && !error && !shops.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (shopList_module_default()).empty,
                    role: "status",
                    children: t("manufacturers.initial.empty", {
                        defaultValue: copy.empty
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    spacing: compact ? 2 : isDesktop ? 4 : 2,
                    children: !loading ? shops.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopCard, {
                                data: item,
                                compact: compact
                            })
                        }, item.id)) : Array.from(new Array(4)).map((_, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            lg: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                variant: "rectangular",
                                className: (shopList_module_default()).shimmer
                            })
                        }, "shops" + idx))
                }),
                hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (shopList_module_default()).loadMore,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(load_more/* default */.Z, {
                        loading: fetchingNextPage,
                        onClick: handleLoadNexPage,
                        children: t("load.more")
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 47951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShopWorkingSchedule; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59108);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98862);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_weekdays__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57686);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89955);




function useShopWorkingSchedule(data) {
    const { order  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((state)=>state.order);
    const { workingSchedule , isShopClosed , isOpen , isTodayDisabled  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        var ref, ref1;
        const isSelectedDeliveryDate = order.shop_id === (data === null || data === void 0 ? void 0 : data.id) && !!order.delivery_date;
        const today = isSelectedDeliveryDate ? order.delivery_date : dayjs__WEBPACK_IMPORTED_MODULE_1___default()().format("YYYY-MM-DD");
        const weekDay = constants_weekdays__WEBPACK_IMPORTED_MODULE_3__/* .WEEK */ .p[isSelectedDeliveryDate ? dayjs__WEBPACK_IMPORTED_MODULE_1___default()(order.delivery_date).day() : dayjs__WEBPACK_IMPORTED_MODULE_1___default()().day()];
        const foundedSchedule = data === null || data === void 0 ? void 0 : (ref = data.shop_working_days) === null || ref === void 0 ? void 0 : ref.find((item)=>item.day === weekDay);
        const isHoliday = data === null || data === void 0 ? void 0 : (ref1 = data.shop_closed_date) === null || ref1 === void 0 ? void 0 : ref1.some((item)=>dayjs__WEBPACK_IMPORTED_MODULE_1___default()(item.day).isSame(isSelectedDeliveryDate ? dayjs__WEBPACK_IMPORTED_MODULE_1___default()(order.delivery_date) : dayjs__WEBPACK_IMPORTED_MODULE_1___default()()));
        const isClosed = !(data === null || data === void 0 ? void 0 : data.open) || isHoliday;
        let schedule = {};
        let isTimePassed = false;
        let isTimeDidNotStart = false;
        try {
            if (foundedSchedule) {
                schedule = {
                    ...foundedSchedule
                };
                schedule.from = schedule.from.replace("-", ":");
                schedule.to = schedule.to.replace("-", ":");
                isTimePassed = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().isAfter("".concat(today, " ").concat(schedule.to));
                isTimeDidNotStart = dayjs__WEBPACK_IMPORTED_MODULE_1___default()().isBefore("".concat(today, " ").concat(schedule.from));
            }
        } catch (err) {
            console.log("err => ", err);
        }
        return {
            workingSchedule: schedule,
            isShopClosed: schedule.disabled || isClosed || isTimePassed || isTimeDidNotStart,
            isOpen: Boolean(data === null || data === void 0 ? void 0 : data.open),
            isTodayDisabled: schedule.disabled
        };
    }, [
        data,
        order.delivery_date,
        order.shop_id
    ]);
    return {
        workingSchedule,
        isShopClosed,
        isOpen,
        isTodayDisabled
    };
}


/***/ }),

/***/ 80462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mp": function() { return /* binding */ SHOP_INITIALS; },
/* harmony export */   "PK": function() { return /* binding */ normalizeShopInitial; },
/* harmony export */   "Sy": function() { return /* binding */ shopAlphabetCopy; },
/* harmony export */   "xD": function() { return /* binding */ shopInitialParam; }
/* harmony export */ });
const SHOP_INITIALS = [
    "",
    "0-9",
    ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("")
];
// Only allow the server's initial-filter contract. Never pass arbitrary search input.
function normalizeShopInitial(value) {
    if (typeof value !== "string") return "";
    const initial = value.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    return initial === "0-9" || /^[A-Z]$/.test(initial) ? initial : "";
}
function shopInitialParam(value) {
    return normalizeShopInitial(value) || undefined;
}
const copy = {
    en: {
        all: "All",
        label: "Filter manufacturers by initial",
        empty: "No manufacturers found for this initial.",
        error: "Unable to load manufacturers. Please try again.",
        retry: "Try again"
    },
    pt: {
        all: "Todos",
        label: "Filtrar fabricantes pela inicial",
        empty: "Nenhum fabricante encontrado para esta inicial.",
        error: "N\xe3o foi poss\xedvel carregar os fabricantes. Tente novamente.",
        retry: "Tentar novamente"
    },
    es: {
        all: "Todos",
        label: "Filtrar fabricantes por inicial",
        empty: "No se encontraron fabricantes para esta inicial.",
        error: "No se pudieron cargar los fabricantes. Int\xe9ntalo de nuevo.",
        retry: "Intentar de nuevo"
    }
};
function shopAlphabetCopy(locale) {
    const language = locale === null || locale === void 0 ? void 0 : locale.toLowerCase().split(/[-_]/)[0];
    return copy[language === "pt" || language === "br" ? "pt" : language === "es" ? "es" : "en"];
}


/***/ }),

/***/ 87459:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__BHeKC","default":"badge_default__18BvY","circle":"badge_circle__mQVZ_","text":"badge_text__cdsyf","large":"badge_large__bhCOW","medium":"badge_medium__3BTPx","bonus":"badge_bonus__Ice67","discount":"badge_discount__gVAeQ","popular":"badge_popular__ywwJB"};

/***/ }),

/***/ 93708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"empty_wrapper__nwTin","text":"empty_text__oRHIv","actions":"empty_actions__NNcWA"};

/***/ }),

/***/ 50937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};

/***/ }),

/***/ 11445:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shopCard_wrapper__eLDR6","header":"shopCard_header__ndTnF","shopLogo":"shopCard_shopLogo__YBVUk","body":"shopCard_body__RaioU","titleContainer":"shopCard_titleContainer__PoAO_","title":"shopCard_title__ZOeFL","maxWidth":"shopCard_maxWidth__hzAq9","text":"shopCard_text__N8BjM","rating":"shopCard_rating__e7b0N","ratingIcon":"shopCard_ratingIcon___i8oO","ratingCount":"shopCard_ratingCount__okJy2","compact":"shopCard_compact__vqfEn","flowBadges":"shopCard_flowBadges__F8r__"};

/***/ }),

/***/ 50782:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"shopLogo_logo__RFCaX"};

/***/ }),

/***/ 34892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"badge":"shopBadges_badge__NpYKe"};

/***/ }),

/***/ 31431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"shopList_container__dXd4J","wrapper":"shopList_wrapper__q4bQb","header":"shopList_header__8uPMd","title":"shopList_title__D3BSf","loadMore":"shopList_loadMore__xxuRm","shimmer":"shopList_shimmer__tOM85","compact":"shopList_compact__RPuzE","alphabet":"shopList_alphabet__aDjRh","initial":"shopList_initial__8vUN1","empty":"shopList_empty__vQp8T","feedback":"shopList_feedback__mOc0Z"};

/***/ })

}]);